<template>
<div class="order-wrapper">
    <portal target-el="#filter">
      <PrimaryFilter
        :menuOptions="menuOptions"
        :selectedCategory="seletedCategory"
        :enableSearchPopup="enableSearchPopup"
        :searchParameters="searchParameters"
        :preSearchedParams="searchedParams"
        :buttonsList="buttonsList"
        :isUploading="isUploading"
        :rejectDownload="rejectCount"
        @searchByParameter="searchByParameter"
        @exportData="exportData"
        @bulkUpload="bulkUpload"
        @getBulkUploadExcel="getBulkUploadExcel"
        @rejectDownload="rejectDownload"
        searchText="Search" />
    </portal>
    <div
      v-infinite-scroll="loadMore"
      infinite-scroll-disabled="loadCheck"
      infinite-scroll-throttle-delay="400"
      infinite-scroll-distance="10">
      <MdmHeader
        :headers="sectionHeaders"
        :noCheckbox="true"
        :hasColumnPicker="true"
        :maxDisplayColumn="5"/>
      <div v-if="isLoading" class="paymentloader"></div>
      <div v-else-if="list.length === 0" class="emptydiv">
        <div class="paymentempty"></div>
        <div class="emptytext">{{$t('MDM_NO_DATA_FOUND')}}</div>
      </div>
      <MdmRow
        v-else
        v-for="(vehicle,index) in vehicleList"
        :key="index"
        :data="vehicle"
        :headers="sectionHeaders"
        :showEdit="showEdit"
        :showUpdate="true"
        :showDepotAvailabilityDrawer="true"
        v-on:edit="openEditDetails(vehicle)"
        @update="updateAvailability(vehicle, $event)"
        />
    </div>
</div>
</template>

<script>
/* eslint-disable import/no-extraneous-dependencies */
import MdmHeader from '@common/components/HeaderV2';
import MdmRow from '@common/components/mdm-v2/Row';
import PrimaryFilter from '@/components/common/PrimaryFilter';
import SharedMdmV2 from '@/components/mixins/SharedMdmV2';

export default {
  components: {
    PrimaryFilter,
    MdmHeader,
    MdmRow,
  },
  mixins: [SharedMdmV2],
  data() {
    return {
      openSlideleft: false,
      transactionIds: [],
      skipEditPermission: true,
      overrideDefaultSearchParms: true,
    };
  },
  created() {
    this.loadMore();
  },
  computed: {
    vehicleList() {
      return this.list && this.list.map((value) => {
        const listOfAvailableVehicles = value.vehicles && value.vehicles.length &&
          value.vehicles.filter(vehicle => vehicle.is_vehicle_available === true);
        const listOfAvailableDepots = [];
        listOfAvailableVehicles.map((vehicle) => {
          if (vehicle.depot_id) {
            listOfAvailableDepots.push(vehicle.depot_id.name);
          }
        });
        const obj = {
          number: value.vehicles && value.vehicles[0].number,
          vehicle_type: (value.vehicles[0].type && value.vehicles[0].type.short_form) ? value.vehicles[0].type.short_form : '-',
          vehicle_model: value.vehicles[0].vehicle_model || '-',
          transporter: (value.vehicles[0].transporter_id &&
            value.vehicles[0].transporter_id.vname) ?
            value.vehicles[0].transporter_id.vname : '-',
          chasis_number: value.vehicles[0].chasis_number || '-',
          depot_availability: (listOfAvailableDepots && listOfAvailableDepots.length) ? listOfAvailableDepots : ['-'],
        };
        return { ...value, ...obj };
      });
    },
    isDestinationDepotEnabled() {
      return this.$hasFeature('vehicle_destination_depot_mapping');
    },
  },
  methods: {
    openEditDetails(data) {
      this.$router.push({ name: 'VehicleDetailEdit',
        params: { id: data.number } });
    },
    constructUploadDataPayload(data) {
      const result = {
        chasis_number: data.chasis_number,
        vehicle_model: data.vehicle_model,
        vehicle_type_id: data.vehicles && data.vehicles[0]
          && data.vehicles[0].type && data.vehicles[0].type._id,
        depots: [],
      };
      const depotsData = data.vehicles
        .filter(vehicle => vehicle.depot_id)
        .map(vehicle => ({
          depot_id: vehicle.depot_id._id,
          tare_weight: vehicle.tare_weight,
          vehicle_length: vehicle.vehicle_length,
          vehicle_width: vehicle.vehicle_width,
          vehicle_height: vehicle.vehicle_height,
          vehicle_uom: vehicle.vehicle_uom,
          vehicle_filled_weight: vehicle.vehicle_filled_weight,
          vehicle_gross_weight: vehicle.vehicle_gross_weight,
          vehicle_volume: vehicle.vehicle_volume,
          is_vehicle_available: vehicle.is_vehicle_available,
          ...(this.isDestinationDepotEnabled && vehicle.destination_depots ? {
            destination_depots: vehicle.destination_depots.map(d => d._id || d.id || d),
          } : {}),
        }));
      result.depots = depotsData;
      return result;
    },
    async updateAvailability(vehicle, data) {
      const payload = this.constructUploadDataPayload(data);
      const number = vehicle.number;
      const transporterId = data.vehicles[0].transporter_id._id;
      const result = await this.$store.dispatch('mdmV2/editVehicleDetails', { payload, number, transporterId });
      if (result && result.error) {
        this.$errorMessage({ message: `Vehicle Details:${result.error}` });
      } else {
        this.$successMessage({ message: this.$t('MDM_VEHICLE_DETAIL_UPDATE_SUCCESS') });
      }
    },
  },
};
</script>
